import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import { ROUTE_DASHBOARD } from '../config/routes';
import { isAuthenticated } from '../api/helper';
import { history } from '../store/store'

class NotAuthenticated extends Component {
  constructor(props) {
    super(props);

    if (isAuthenticated()) {
      history.push(ROUTE_DASHBOARD);
    }
  }

  render() {
    const { component: Component, ...props } = this.props;
    return (
      <Route {...props} render={props => (<Component {...props} />)}/>
    )
  }
}

export default withRouter(NotAuthenticated);
